import { FC } from 'react';
import BordOneToneIcon from '../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { copyClipboard } from '../../../../../../../utils/copyClipboard';
import { IAgentResponse } from '../../../../../../../types/agentChat.types';
import './AgentChatMessage.scss';

interface IAgentChatMessage {
  messageDate?: string;
  message?: string;
  messageData?: IAgentResponse;
  isError?: boolean;
  handleClick?: () => void;
  displayHistoryUI?: boolean;
  isAgentResponse?: boolean;
  customClassName?: string;
}

const AgentChatMessage: FC<IAgentChatMessage> = ({
  message,
  displayHistoryUI,
  isError,
  messageDate,
  isAgentResponse,
  handleClick,
  customClassName
}) => {
  const agentMessage = isError
    ? 'Lo siento, hubo un error al procesar tu consulta. Como este chat no es generativo, te recomiendo iniciar una nueva conversación para intentar de nuevo.'
    : message;

  const handleCopyMessage = () => {
    if (agentMessage) copyClipboard({ text: agentMessage });
  };

  return (
    <div className={`agentChatMessage ${isError ? 'errorMessage' : ''} ${customClassName}`} onClick={handleClick}>
      <div className={`messageContent ${displayHistoryUI ? 'historyMode' : ''}`}>
        <div className="messageText">{agentMessage}</div>
        {!!displayHistoryUI && !isError && (
          <BordOneToneIcon variant="arrowRight" customWidth="14px" className="arrowIcon" stroke="#383838" />
        )}
      </div>

      <div className="messageFooter">
        {!isError && isAgentResponse && (
          <div className="copyMessage" onClick={handleCopyMessage}>
            <BordOneToneIcon variant="document" customWidth="10px" stroke="#999" standardSize={10} />
            Copiar
          </div>
        )}
        <div className="messageTime">{messageDate}</div>
      </div>
    </div>
  );
};

export default AgentChatMessage;
